import React from 'react';
import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';
import { C48ReputationScheduleCTAProps } from './C48ReputationScheduleCTA.types';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { PromptForUnavailableInTheme } from 'src/shared/PromptForUnavailableInTheme';
import { ReputationScheduleCta } from '@ahc-digital/component-library';
import { CreateReputationScheduleCTAModel } from './C48ReputationScheduleCTA.service';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: C48ReputationScheduleCTAProps): JSX.Element => {
  const context = useCustomSitecoreContext();
  const doctorSearchURL: string = context?.doctorSearchURL?.value ?? '';
  const locationSearchURL: string = context?.locationSearchURL?.value ?? '';
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (context?.siteTheme?.value === 'Corporate')
    return (
      <PromptForUnavailableInTheme
        siteTheme={context?.siteTheme?.value}
        componentName={props?.rendering?.componentName}
      />
    );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  const model = CreateReputationScheduleCTAModel(props, doctorSearchURL, locationSearchURL);
  return <ReputationScheduleCta {...model} data-component={marketingRenderingName} />;
};
